import { Modal, ModalCloseButton, ModalConfirmButton, ModalWidth } from '@dreryk/react-components';

import { patientTranslationKeys } from '../../translations';
import { DisplayableMessage } from '../../common/displayableMessage/DisplayableMessage';

type PatientCannotBeRemovedModalProps = {
   displayableMessage: DisplayableMessage;
   onClose: VoidFunction;
};

export const PatientCannotBeRemovedModal = (props: PatientCannotBeRemovedModalProps): JSX.Element => {
   return (
      <Modal
         testId={'patientCannotBeRemoved'}
         title={patientTranslationKeys.cannotRemovePatient}
         width={ModalWidth.NORMAL}
      >
         <DisplayableMessage {...props.displayableMessage} />
         <ModalConfirmButton label={patientTranslationKeys.close} onClick={props.onClose} />
         <ModalCloseButton onClick={props.onClose} />
      </Modal>
   );
};
